// extracted by mini-css-extract-plugin
export var animateOpacity = "CompanyValues-module--animateOpacity--901a7";
export var committedToAnimals = "CompanyValues-module--committedToAnimals--d948d";
export var companyValues = "CompanyValues-module--companyValues--529cf";
export var companyValuesBodyWrapper = "CompanyValues-module--companyValuesBodyWrapper--79da3";
export var companyValuesBodyWrapperAnimation = "CompanyValues-module--companyValuesBodyWrapperAnimation--734d8";
export var companyValuesBodyWrapperNotVisited = "CompanyValues-module--companyValuesBodyWrapperNotVisited--b32d4";
export var companyValuesDescription = "CompanyValues-module--companyValuesDescription--2736f";
export var companyValuesHeader = "CompanyValues-module--companyValuesHeader--94840";
export var designedByPetParents = "CompanyValues-module--designedByPetParents--2d4b5";
export var pageWrapper = "CompanyValues-module--page-wrapper--34e76";
export var sectionTitle = "CompanyValues-module--sectionTitle--e4014";
export var socialCauses = "CompanyValues-module--socialCauses--fc899";